import ProductsHeader from "./ProductsHeader"
import ProductTypes from "./ProductTypes"
import Footer from '../../shared/Footer'

function Products() {
  return (
    <>
        <ProductsHeader />
        <ProductTypes />
        <Footer />
    </>
  )
}

export default Products